import 'regenerator-runtime/runtime'
import 'core-js/fn/object/assign'
import 'core-js/fn/array/find'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/fill'
import 'core-js/fn/string/starts-with'
import React from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import createStore from './src/store/createStore'

exports.replaceRouterComponent = ({ history }) => {
  const { store, persistor } = createStore(history)

  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>{children}</ConnectedRouter>
      </PersistGate>
    </Provider>
  )

  return ConnectedRouterWrapper
}



// WEBPACK FOOTER //
// ./gatsby-browser.js